/**
 * CONSAI - Invoice Totals Summary Component
 * Displays GST breakdown and grand total
 */
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const TotalsSummary = ({ totals, discountType, discountValue }) => {
  const { language } = useLanguage();

  return (
    <div className="bg-slate-50 p-4 rounded-lg space-y-2">
      <div className="flex justify-between text-sm">
        <span className="text-slate-500">{language === 'hi' ? 'उप-योग' : 'Subtotal'}</span>
        <span>Rs.{totals.subtotal.toFixed(2)}</span>
      </div>
      
      {totals.isInterstate ? (
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">IGST</span>
          <span>Rs.{totals.igstTotal.toFixed(2)}</span>
        </div>
      ) : (
        <>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">CGST</span>
            <span>Rs.{totals.cgstTotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">SGST</span>
            <span>Rs.{totals.sgstTotal.toFixed(2)}</span>
          </div>
        </>
      )}
      
      <div className="flex justify-between text-sm font-medium border-t border-slate-200 pt-2">
        <span className="text-slate-600">{language === 'hi' ? 'उप-योग (GST सहित)' : 'Subtotal (Including GST)'}</span>
        <span>Rs.{totals.subtotalWithGst.toFixed(2)}</span>
      </div>
      
      {totals.discountAmount > 0 && (
        <div className="flex justify-between text-sm text-amber-600">
          <span>
            {language === 'hi' ? 'छूट' : 'Discount'}
            {discountType === 'percent' && ` (${discountValue}%)`}
          </span>
          <span>-Rs.{totals.discountAmount.toFixed(2)}</span>
        </div>
      )}
      
      {totals.roundOff !== 0 && (
        <div className="flex justify-between text-sm">
          <span className="text-slate-500">{language === 'hi' ? 'राउंड ऑफ' : 'Round Off'}</span>
          <span>{totals.roundOff > 0 ? '+' : ''}Rs.{totals.roundOff.toFixed(2)}</span>
        </div>
      )}
      
      <div className="flex justify-between text-lg font-bold font-manrope pt-2 border-t border-slate-200">
        <span>{language === 'hi' ? 'कुल राशि' : 'Grand Total'}</span>
        <span className="text-[#d7263d]">Rs.{totals.grandTotal.toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
};

export default TotalsSummary;
